"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const ContactAddressTooltip = () => (react_1.default.createElement(CustomToolTip_1.default, { type: '?', info: 'Mailing address information is completely optional. ' +
        'If you would like to include an address, you may use a P.O. Box or care/of address.', place: 'right' }));
exports.default = ContactAddressTooltip;
